import React from 'react';
import styled, { css } from 'styled-components';

const UncontrolledSegmentedButtonParent = ({ children, className }) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, child.props);
    }
    return child;
  });

  return <div className={className}>{childrenWithProps}</div>;
};

const UncontrolledSegmentedButtonChildren_ = ({ className, children, ...props }) => {
  return (
    <label htmlFor={props.id} className={className}>
      <input type="radio" {...props} />
      <div className="UncontrolledSegmented__label">{children}</div>
    </label>
  );
};

const erroredStyles = ({ hasError }) =>
  hasError &&
  css`
    .UncontrolledSegmented__label {
      &,
      &:hover {
        box-shadow: 0 0 0 1px var(--error900);
        background-color: var(--error100);
      }
    }
  `;

export const UncontrolledSegmentedButtonChildren = styled(UncontrolledSegmentedButtonChildren_)`
  .UncontrolledSegmented__label {
    background-color: var(--white);
    padding: 8px;
    cursor: pointer;
    box-shadow: 0 0 0 1px var(--grey500);
    color: var(--secondary500);
    margin-top: 1px;
    margin-left: 1px;
    position: relative;
    z-index: 1;

    &:hover {
      z-index: 2;
      color: var(--primary700);
      box-shadow: 0 0 0 1px var(--primary300);
      background-color: var(--primary50);
    }
  }

  &:first-child {
    .UncontrolledSegmented__label {
      border-radius: 4px 0 0 4px;
    }
  }
  &:last-child {
    .UncontrolledSegmented__label {
      border-radius: 0 4px 4px 0;
    }
  }

  input[type='radio']:focused + .UncontrolledSegmented__label {
    z-index: 2;
    color: var(--primary700);
    box-shadow: 0 0 0 1px var(--primary300);
    background-color: var(--primary50);
  }

  input[type='radio'],
  [type='checkbox'] {
    &:checked + .UncontrolledSegmented__label {
      z-index: 2;
      color: var(--primary700);
      box-shadow: 0 0 0 1px var(--primary500);
      background-color: var(--primary50);
    }
    &:disabled + .UncontrolledSegmented__label {
      opacity: 50%;
      cursor: default;
    }
  }

  input[type='radio'],
  input[type='checkbox'] {
    opacity: 0;
    position: absolute;
    left: -99999px;
  }

  ${erroredStyles}
`;

export default styled(UncontrolledSegmentedButtonParent)`
  & {
    display: inline-flex;
  }
`;
